import { useGetUserSuspense } from "@partners/ui/api";
import { useRouterState } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { ProfileMenu } from "@/components/ProfileMenu";

import { AuthenticatedBaseHeader } from "./AuthenticatedBaseHeader";
import { getNavLinksOverviewOnly } from "./getNavLinks";

export const AuthenticatedHeaderOnlySignedUp = () => {
  const { t } = useTranslation();
  const { location } = useRouterState();
  const { data } = useGetUserSuspense();
  const isIdentityOnlyUser = data.onboardingState === "OnlyAuth0Created";

  const profileMenu = (
    <ProfileMenu
      onboardingState={data.onboardingState}
      isMAMMaster={data.isMAMMaster}
      isTriageEnabled={false}
      hasTriagesCompleted={false}
      isIdentityOnlyUser={isIdentityOnlyUser}
      userName={data.name}
    />
  );

  return (
    <AuthenticatedBaseHeader
      profileMenuComponent={profileMenu}
      navLinks={isIdentityOnlyUser ? [] : getNavLinksOverviewOnly(t)}
      selectedNavLink={location.pathname}
      launchPersonalTradingLinkLabel={t(
        "global_header_launchPersonalTrading_link",
      )}
      isIdentityOnlyUser={isIdentityOnlyUser}
    />
  );
};
